define( [
	"./arr"
], function( arr ) {
	"use strict";

	return arr.indexOf;
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/var/indexOf.js
// module id = guk2
// module chunks = 0 1